var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8C(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.485,
    y1: 26.0094,
    x2: 32.485,
    y2: 39.6002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A6DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    style: {
      stopColor: "#C822FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M26.07,35.31l6.17-3.6l6.66,3.92c-1.3,2.29-3.69,3.7-6.33,3.7 C29.73,39.33,27.26,37.69,26.07,35.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163778382194180662180000015548504688157496507_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 27.121,
    x2: 32,
    y2: 56.3717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A6DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    style: {
      stopColor: "#C822FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163778382194180662180000015548504688157496507_)"
    },
    d: "M52.6,43.67v0.22L32,55.79l-20.6-11.9 l7.7-4.5c2.6,4.77,7.67,8.01,13.47,8.01c5.52,0,10.55-2.93,13.29-7.69L52.6,43.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060011424156101658330000007545567359354640293_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.93,
    y1: 24.8101,
    x2: 31.93,
    y2: 35.29
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060011424156101658330000007545567359354640293_)"
    },
    d: "M38.55,27.97l-6.35,3.72h-0.01l-6.13,3.6 c-0.48-0.97-0.75-2.06-0.75-3.22c0-1.39,0.39-2.68,1.07-3.79c1.28-2.08,3.57-3.47,6.19-3.47C34.98,24.81,37.2,25.98,38.55,27.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004531558720369303850000013354417349751162025_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.87,
    y1: 8.21,
    x2: 31.87,
    y2: 43.89
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004531558720369303850000013354417349751162025_)"
    },
    d: "M45.12,24.1l0.39-0.24 c-2.83-4.45-7.67-7.12-12.94-7.12c-5.58,0-10.47,3-13.15,7.46c-1.38,2.31-2.18,4.99-2.18,7.87c0,2.65,0.67,5.13,1.85,7.3 l-7.69,4.52V20.11L32,8.21l20.34,11.75L45.12,24.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090294102037059265810000000097383806955157422_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.25,
    y1: 32.7039,
    x2: 15.25,
    y2: 48.6153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090294102037059265810000000097383806955157422_)"
    },
    d: "M19.09,39.37c0,0.01,0.01,0.01,0.01,0.02 l-7.7,4.5L19.09,39.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018238327259810187750000015450832496473162146_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.15,
    y1: 26.351,
    x2: 29.15,
    y2: 39.0945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018238327259810187750000015450832496473162146_)"
    },
    d: "M32.24,31.71l-6.17,3.6 c0-0.01-0.01-0.01-0.01-0.02l6.13-3.6h0.01L32.24,31.71z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088127717672633308680000009055284225772296835_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.25,
    y1: 30.6709,
    x2: 15.25,
    y2: 43.89
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088127717672633308680000009055284225772296835_)"
    },
    d: "M19.09,39.37c0,0.01,0.01,0.01,0.01,0.02 l-7.7,4.5L19.09,39.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112602905369188770390000003987056642699955850_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.15,
    y1: 24.7227,
    x2: 29.15,
    y2: 35.3101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112602905369188770390000003987056642699955850_)"
    },
    d: "M32.24,31.71l-6.17,3.6 c0-0.01-0.01-0.01-0.01-0.02l6.13-3.6h0.01L32.24,31.71z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120539603571993944960000017918077651240302227_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.27,
    y1: 13.6979,
    x2: 42.27,
    y2: 56.6406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000120539603571993944960000017918077651240302227_)"
    },
    points: "52.34,19.96 32.24,31.71  32.2,31.69 38.55,27.97 45.12,24.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022520761314102075240000004815537480656993696_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.27,
    y1: 8.21,
    x2: 42.27,
    y2: 43.8867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000022520761314102075240000004815537480656993696_)"
    },
    points: "52.34,19.96 32.24,31.71  32.2,31.69 38.55,27.97 45.12,24.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179637352601101775860000018097081689990482623_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 1.2553,
    x2: 32,
    y2: 56.0809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A6DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C822FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179637352601101775860000018097081689990482623_)"
    },
    d: "M55.1,16.93L33.5,4.46 c-0.93-0.53-2.07-0.53-3,0L8.9,16.93c-0.92,0.54-1.5,1.53-1.5,2.6v24.94c0,1.07,0.58,2.06,1.5,2.6l21.6,12.47 c0.93,0.53,2.07,0.53,3,0l21.6-12.47c0.92-0.54,1.5-1.53,1.5-2.6V19.53C56.6,18.46,56.02,17.47,55.1,16.93z M54.6,44.47 c0,0.36-0.19,0.69-0.5,0.87L32.5,57.81c-0.31,0.17-0.69,0.17-1,0L9.9,45.34c-0.31-0.18-0.5-0.51-0.5-0.87V19.53 c0-0.36,0.19-0.69,0.5-0.87L31.5,6.19c0.31-0.17,0.69-0.17,1,0l21.6,12.47c0.31,0.18,0.5,0.51,0.5,0.87V44.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "45.86,39.7 45.86,39.71 38.9,35.63  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094618989716905808560000002089984014827651767_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.42,
    y1: 21,
    x2: 42.42,
    y2: 48.7447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#E6ABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094618989716905808560000002089984014827651767_)"
    },
    d: "M52.34,19.96l-20.1,11.75l6.66,3.92 l6.96,4.08l6.74,3.96V20.11L52.34,19.96z M44,33h-2v2h-2v-2h-2v-2h2v-2h2v2h2V33z M51,33h-2v2h-2v-2h-2v-2h2v-2h2v2h2V33z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8C);
export default __webpack_public_path__ + "static/media/icons8-c.607521127c3c9e99bfca386508acff1a.svg";
export { ForwardRef as ReactComponent };